import Blockquote from './Blockquote';

export default Blockquote;
